import { createContext, useContext } from 'react';
import { GC_2025_LOGO, GiftCardVariants } from '../components/CustomizePage/GiftCard/GiftCard';
import GiftSubscription from '../types/GiftSubscription';

export type GiftCustomizeParams = {
  message: string;
  recipientEmail: string;
  recipientName: string;
  sendDate: Date;
  senderEmail: string;
  sendMethod: 'email' | 'print';
  senderName: string;
  variant: GiftCardVariants;
};

export type GiftFlowState = {
  giftCustomizeParams: GiftCustomizeParams;
  purchasedGiftCard?: GiftSubscription;
  serverErrors: any;
};

export type GiftContext = {
  dispatchGiftFlow: any;
  giftFlowState: GiftFlowState;
};

export const initialState: GiftFlowState = {
  giftCustomizeParams: {
    variant: GC_2025_LOGO,
    sendMethod: 'email',
    sendDate: new Date(),
    recipientName: '',
    recipientEmail: '',
    message: '',
    senderName: '',
    senderEmail: ''
  },
  serverErrors: [] as any
};

export const GiftFlowContext = createContext<GiftContext>({ dispatchGiftFlow: null, giftFlowState: initialState });

export function useGiftFlowContext() {
  const context = useContext(GiftFlowContext);
  return context;
}

export const UPDATE_GIFT_CUSTOMIZE_FORM = 'UPDATE_GIFT_CUSTOMIZE_FORM';
export const UPDATE_SERVER_ERRORS = 'UPDATE_SERVER_ERRORS';
export const UPDATE_PURCHASED_GIFT_CARD = 'UPDATE_PURCHASED_GIFT_CARD';
export const RESTART_GIFT_FLOW = 'RESTART_GIFT_FLOW';

export const giftFlowReducer = (state: any, action: any) => {
  switch (action.type) {
    case UPDATE_GIFT_CUSTOMIZE_FORM: {
      return { ...state, giftCustomizeParams: action.payload };
    }
    case UPDATE_SERVER_ERRORS: {
      return { ...state, serverErrors: action.payload };
    }
    case UPDATE_PURCHASED_GIFT_CARD:
      return { ...state, purchasedGiftCard: action.payload };
    case RESTART_GIFT_FLOW:
      return { ...state, ...initialState };
    default:
      return state;
  }
};
